export const CONSENT_VERSION = '2026-11-04';
